import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/auth/auth.guard';
import { Role } from './core/auth/enums/role.enum';
import { LogoutComponent } from './layout/logout/logout.component';
import { ResetPasswordComponent } from './shared/reset-password/reset-password.component';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./features/home/home.module').then((m) => m.HomeModule),
    data: {
      roles: [Role.ALL],
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'companies',
    loadChildren: () =>
      import('./features/company-administration/company-administration.module').then((m) => m.CompanyAdministrationModule),
    data: {
      roles: [Role.ADMIN],
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'chat',
    loadChildren: () => import('./features/admin-and-company-chat/admin-and-company-chat.module').then((m) => m.AdminAndCompanyChatModule),
    data: {
      roles: [Role.ADMIN, Role.COMPANY_ADMIN, Role.SALES_REP, Role.MSL, Role.PATIENT_ASSISTANCE],
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'alerts',
    loadChildren: () => import('./features/alerts/alerts.module').then((m) => m.AlertsModule),
    data: {
      roles: [Role.ADMIN, Role.COMPANY_ADMIN],
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'analytics',
    loadChildren: () => import('./features/analytics/analytics.module').then((m) => m.AnalyticsModule),
    data: {
      roles: [Role.ADMIN, Role.COMPANY_ADMIN],
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'company-products',
    loadChildren: () => import('./features/company-products/company-products.module').then((m) => m.CompanyProductsModule),
    data: {
      roles: [Role.COMPANY_ADMIN],
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'physician-users',
    loadChildren: () => import('./features/physician-users/physician-users.module').then((m) => m.PhysicianUsersModule),
    data: {
      roles: [Role.ADMIN],
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'news-administration',
    loadChildren: () => import('./features/news/news.module').then((m) => m.NewsModule),
    data: {
      roles: [Role.ADMIN],
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'company-users',
    loadChildren: () => import('./features/company-users/company-users.module').then((m) => m.CompanyUsersModule),
    data: {
      roles: [Role.ADMIN, Role.COMPANY_ADMIN],
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'teritories',
    loadChildren: () => import('./features/company-teritories/company-teritories.module').then((m) => m.CompanyTeritoriesModule),
    data: {
      roles: [Role.ADMIN, Role.COMPANY_ADMIN, Role.SALES_REP, Role.MSL, Role.PATIENT_ASSISTANCE],
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'reset-password',
    component: ResetPasswordComponent,
    data: {
      roles: [Role.ALL],
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'logout',
    component: LogoutComponent,
    canActivate: [AuthGuard],
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled', initialNavigation: 'enabledBlocking' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
